var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetpromotedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.718C20.128 5.718 20.256 5.669 20.354 5.572L22.354 3.572C22.549 3.377 22.549 3.06 22.354 2.865C22.16 2.67 21.842 2.67 21.647 2.865L19.647 4.865C19.452 5.06 19.452 5.377 19.647 5.572C19.744 5.67 19.872 5.718 20 5.718Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.354 12.865C20.16 12.67 19.842 12.67 19.647 12.865C19.453 13.06 19.453 13.377 19.647 13.572L21.647 15.572C21.746 15.67 21.874 15.718 22.001 15.718C22.128 15.718 22.257 15.669 22.355 15.572C22.549 15.377 22.549 15.06 22.355 14.865L20.354 12.865Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 8.71899H21C20.725 8.71899 20.5 8.94299 20.5 9.21899C20.5 9.49499 20.725 9.71899 21 9.71899H24C24.275 9.71899 24.5 9.49499 24.5 9.21899C24.5 8.94299 24.275 8.71899 24 8.71899Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.719V5.71899H3.5C1.57 5.71899 0 7.28899 0 9.21899C0 11.149 1.57 12.719 3.5 12.719H6Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.139 0.800926C14.922 0.738926 14.694 0.826926 14.576 1.01593C12.892 3.70493 10.104 5.38793 7 5.66193V12.7749C10.104 13.0479 12.895 14.7319 14.576 17.4209C14.669 17.5699 14.831 17.6559 15 17.6559C15.046 17.6559 15.092 17.6499 15.139 17.6349C15.352 17.5729 15.5 17.3779 15.5 17.1559V1.28093C15.5 1.05793 15.354 0.861926 15.139 0.800926Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.4021V12.0351C17.663 11.6211 18.5 10.5221 18.5 9.2191C18.5 7.9161 17.663 6.8161 16.5 6.4021Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0251 17.971C4.1451 18.678 4.7571 19.219 5.5001 19.219C6.2431 19.219 6.8541 18.678 6.9751 17.971L7.6711 13.864H3.3291L4.0251 17.971Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetpromotedIcon);
export default __webpack_public_path__ + "static/media/setpromoted_icon.a5b523d07a2090ad6c3f48baad11f5b9.svg";
export { ForwardRef as ReactComponent };